import Modal from './Modal'
import EventBus from '../core/EventBus'
import Component from '../core/Component'
import { CMS } from '../core/config.js'

const STATES = {
    CHANGING: 'is-changing'
}

export default class ProductModal extends Modal {
    constructor(element) {
        super(element)

        this.options = {
            scroll: true,
            preload: true,
            filterResponse: function (html) {
                const buffer = document.createElement('div')
                buffer.innerHTML = html
                const content = buffer.querySelector('[data-modal-content]')
                const data = {}
                if (content) {
                    data.content = content.outerHTML
                }

                const title = buffer.querySelector('[data-modal-title]')
                if (title) {
                    data.title = title.innerText
                }
                return data
            }
        }

        this.cache = {}
    }

    prepare() {
        super.prepare()

        this.element.addEventListener('click', this.handleElementClick)
        EventBus.on('product:card:click', this.handleProductClick)
    }

    destroy() {
        super.destroy()
        EventBus.off('product:card:click', this.handleProductClick)
    }

    handleElementClick = event => {
        const target = event.target.closest('[data-rel="product"]')
        if (target) {
            if (CMS) {
                return
            }
            event.preventDefault()
            this.changeContent(target.href)
        }
    }

    handleProductClick = ({ url, state, element }) => {
        if (this.isActive) {
            this.changeContent(url)
        } else {
            this.options.url = url
            this.open(element)
        }
        this.changeContent(url)
    }

    changeContent(url) {
        this.element.classList.add(STATES.CHANGING)

        Promise.all([
            new Promise(resolve => {
                setTimeout(resolve, 100)
            }),
            this.fetch(url)
        ]).then(result => {
            const response = this.options.filterResponse(result[1])
            this.cache[url] = response.content
            this.setContent(response)
            this.ref.content.scrollTop = 0
            this.ref.inner.scrollTop = 0
            this.ref.layer.scrollTop = 0

            Component.getFromElement(this.ref.inner)?.scrollbar?.setPosition(0, 0)
            this.element.classList.remove(STATES.CHANGING)

            if (this.isActive) {
                const state = { ...window.history.state }
                state.url = url
                history.replaceState(state, state.title, state.url)
            }
        })
    }

    fetch(url) {
        if (url in this.cache) {
            return this.cache[url]
        } else {
            return $.ajax({
                url: url,
                dataType: 'HTML'
            })
        }
    }
}
